import { __exports as CODE128B } from "./index212.js";
import { __require as requireCODE128 } from "./index208.js";
import { __require as requireConstants } from "./index211.js";
var hasRequiredCODE128B;
function requireCODE128B() {
  if (hasRequiredCODE128B) return CODE128B;
  hasRequiredCODE128B = 1;
  Object.defineProperty(CODE128B, "__esModule", {
    value: true
  });
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _CODE2 = requireCODE128();
  var _CODE3 = _interopRequireDefault(_CODE2);
  var _constants = requireConstants();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CODE128B$1 = (function(_CODE) {
    _inherits(CODE128B2, _CODE);
    function CODE128B2(string, options) {
      _classCallCheck(this, CODE128B2);
      return _possibleConstructorReturn(this, (CODE128B2.__proto__ || Object.getPrototypeOf(CODE128B2)).call(this, _constants.B_START_CHAR + string, options));
    }
    _createClass(CODE128B2, [{
      key: "valid",
      value: function valid() {
        return new RegExp("^" + _constants.B_CHARS + "+$").test(this.data);
      }
    }]);
    return CODE128B2;
  })(_CODE3.default);
  CODE128B.default = CODE128B$1;
  return CODE128B;
}
export {
  requireCODE128B as __require
};
//# sourceMappingURL=index162.js.map
